import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import Formatter from '../../../formatter';
import getFileName from '../../../utils/pathUtil/getFileName';
import getFileThumbnailPath from '../../../utils/pathUtil/getFileThumbnailPath';
import Utils from '../../../utils';

var getActionsApiUrl = function getActionsApiUrl(item, gridProps, inline) {
  var variant = gridProps.dataProps.variant;
  var portal = variant === 'portal';
  var resourceToken = item.ResourceToken;
  var path = encodeURIComponent(item.Path);
  var workspace = item.Workspace;
  var host = Utils.getHost() || '/';
  return "".concat(host, "backend/content?resourceToken=").concat(resourceToken, "&path=").concat(path, "&workspace=").concat(workspace, "&portal=").concat(portal, "&inline=").concat(inline);
};

var COMMUNICATION_OUTPUT_DATA_TYPE = {
  data: {
    url: '/backend/communicationOutput',
    dataKey: 'communicationOutput',
    idKeyProp: 'Path',
    onBeforeRequest: function onBeforeRequest(options, request) {
      if (request.type === 'loadView' && options.dataProps) return _objectSpread({}, request, {
        query: _objectSpread({}, request.query, {
          jobId: options.dataProps.jobId,
          communication: options.dataProps.communication
        })
      });
    }
  },
  columns: [{
    id: 'Path',
    formatter: function formatter(data) {
      return data.Path;
    },
    serverSort: false
  }],
  thumbnail: {
    url: function url(data) {
      return getFileThumbnailPath({
        path: data.Path,
        workspace: data.Workspace,
        token: data.ResourceToken
      });
    },
    text: function text(data) {
      return getFileName(data.Path);
    },
    icon: function icon(data) {
      return {
        path: data.Path
      };
    }
  },
  contextMenu: [{
    label: 'Open',
    id: 'open',
    type: 'custom',
    onClick: function onClick(e, item, gridProps) {
      var apiUrl = getActionsApiUrl(item, gridProps, true);
      window.open(apiUrl, '_self', '');
    },
    hidden: function hidden(item) {
      return item.Type !== 'PDF';
    }
  }, {
    label: 'Download',
    id: 'download',
    type: 'custom',
    onClick: function onClick(e, item, gridProps) {
      var apiUrl = getActionsApiUrl(item, gridProps, false);
      window.open(apiUrl, '_blank', '');
    }
  }]
};
export default COMMUNICATION_OUTPUT_DATA_TYPE;